import { render, staticRenderFns } from "./servicePolicy.vue?vue&type=template&id=3950e1ee&scoped=true&"
import script from "./servicePolicy.vue?vue&type=script&lang=js&"
export * from "./servicePolicy.vue?vue&type=script&lang=js&"
import style0 from "./servicePolicy.vue?vue&type=style&index=0&id=3950e1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3950e1ee",
  null
  
)

export default component.exports